define("shared/components/shared/post/secondary/activity/divider", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <li class="cAP--list__timestamp">
    <span>{{@divider.timestamp}}</span>
  </li>
  */
  {
    "id": "ryxQ2XG5",
    "block": "[[[10,\"li\"],[14,0,\"cAP--list__timestamp\"],[12],[1,\"\\n  \"],[10,1],[12],[1,[30,1,[\"timestamp\"]]],[13],[1,\"\\n\"],[13]],[\"@divider\"],false,[]]",
    "moduleName": "shared/components/shared/post/secondary/activity/divider.hbs",
    "isStrictMode": false
  });
  class DividerComponent extends _component2.default {}
  _exports.default = DividerComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, DividerComponent);
});